import { Box, Grid } from "@material-ui/core";
import CustomInput from "components/CustomInput";
import { vendorInvoiceStyles } from "../style";
import { useGetInvoiceAccountsQuery } from "features/invoice/loads/loadInvoiceSlice";
import DropdownFilter from "components/DropdownFilter";
import { arrayToObject } from "utils/object-util";
import FormatService from "services/formatService";
import usePrompt from "hooks/usePrompt";
import { quickBooksMappingEntityTypes } from "features/invoice/shared/QuickBooksMapping/QuickBooksMappingConsts";
import { useGetQuickbooksMappingByTypeQuery } from "features/invoice/shared/QuickBooksMapping/QuickBooksMappingSlice";
import ActivityStatusAliasView from "features/activityStatusAlias";
import { IconActivityDefault } from "icons/mechanicals";

export const EditVendorService = ({
    onFieldChange,
    serviceToEdit,
    index,
    selectedVehicles,
    matchingWorkOrders = [],
    activityItemLookup,
    services,
    setServices
}) => {
    const classes = vendorInvoiceStyles();
    const { triggerPrompt } = usePrompt();

    // const mappedSelectedVehicles = selectedVehicles?.map(v => ({ name: getVehicleOptionLabel(v), id: v.vehicleId })) || [];

    let { data: invoiceAccounts, error: accountsError, isFetching: accountsFetching } = useGetInvoiceAccountsQuery({});
    invoiceAccounts = invoiceAccounts || [];
    let {
        data: mappedQbAccount,
        error: mappedQbAccountError,
        isFetching: isLoadingappedQbAccount
    } = useGetQuickbooksMappingByTypeQuery({ type: quickBooksMappingEntityTypes.ACTIVITY_ITEM });
    mappedQbAccount = mappedQbAccount?.data || [];

    const invoiceAccountsLookup = arrayToObject(invoiceAccounts)
    const mappedQbAccountLookup = arrayToObject(mappedQbAccount, 'entityId');


    const onWOFieldChange = (value, index) => {
        const updatedServices = [...services];
        let updatedService = {
            ...updatedServices[index],
            'workOrderId': value?.workOrderId || null,
            'activityItemId': value?.activityItemId || null,
            'activityDate': value?.activityDate || null,
            'activityLogId': value?.id || null
        };
        // If there's a mapped QB account for the selected activity item, set it
        if (mappedQbAccount && value?.activityItemId) {
            const mapping = mappedQbAccountLookup?.[value.activityItemId];
            if (mapping) {
                const qbAccount = invoiceAccountsLookup?.[mapping.quickbooksId];
                triggerPrompt({
                    title: "Match QuickBooks Category",
                    content: <>
                        <div>A mapped QB category was found for the selected activity: <b>{qbAccount?.fullyQualifiedName}</b></div>
                        <div>Do you want to populate it on the service line?</div>
                    </>,
                    onConfirm: () => {
                        updatedService = { ...updatedService, 'qbAccountId': mapping.quickbooksId };
                        updatedServices[index] = updatedService;
                        setServices(updatedServices);
                    },
                    onCancel: () => { },
                });
            }
        }
        updatedServices[index] = updatedService;
        setServices(updatedServices);
    };

    let matchingWorkOrdersList = matchingWorkOrders || [];

    if (serviceToEdit?.workOrderId && !matchingWorkOrdersList.find(w => w.workOrderId == serviceToEdit?.workOrderId)) {
        matchingWorkOrdersList = [...matchingWorkOrdersList,
        {
            workOrderId: serviceToEdit?.workOrderId,
            id: serviceToEdit?.workOrderId,
            activityDate: serviceToEdit?.activityDate,
            activityItemId: serviceToEdit?.activityItemId,
            activityName: activityItemLookup?.[serviceToEdit?.activityItemId]?.name || '',
            formattedDate: FormatService.formatDate(serviceToEdit?.activityDate),
            name: `${activityItemLookup?.[serviceToEdit?.activityItemId]?.name || ''} - ${FormatService.formatDate(serviceToEdit?.activityDate)}`
        }];
    }

    const renderOption = (option) => {
        return (
            <Box>
                {option?.activityName &&
                    <Grid container xs={12} alignItems='center' justifyContent='space-between'>
                        <Grid item className={classes.itemIcon}>
                            <IconActivityDefault width={20} height={20} />
                        </Grid>
                        <Grid item >
                            <Grid container direction='column'>
                                <Grid item>
                                    <b>Activity: </b>
                                    {option?.activityName}
                                </Grid>
                                {option?.formattedDate ? <Grid item >
                                    <b>Date: </b>
                                    {option?.formattedDate}
                                </Grid> : <></>}
                                <Grid item>
                                    <b>Status: </b>
                                    <ActivityStatusAliasView
                                        activityIds={[option?.activityId]}
                                        readonly
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>}
            </Box>
        )
    }


    return (
        <>
            <Grid item xs={3}>
                <CustomInput
                    label="Description"
                    value={serviceToEdit?.description}
                    onChange={(val) => onFieldChange('description', val, index)}
                    elementType="input"
                />
            </Grid>
            <Grid item xs={2} >
                <CustomInput
                    value={serviceToEdit?.qbAccountId}
                    onChange={(val) => onFieldChange('qbAccountId', val, index)}
                    elementType="dropdown"
                    values={invoiceAccounts?.map(i => ({ ...i, name: i.fullyQualifiedName }))}
                    showEmpty
                />
            </Grid>
            <Grid item xs={1}>
                <CustomInput
                    label="Quantity"
                    value={serviceToEdit?.quantity}
                    onChange={(val) => onFieldChange('quantity', val, index)}
                    elementType="input"
                    numberOnly
                />
            </Grid>
            <Grid item xs={1}>
                <CustomInput
                    label="Unit Price"
                    value={serviceToEdit?.unitPrice}
                    onChange={(val) => onFieldChange('unitPrice', val, index)}
                    elementType="input"
                    numberOnly
                />
            </Grid>
            <Grid item xs={1}>
                <CustomInput
                    label="Price"
                    value={serviceToEdit?.price}
                    onChange={(val) => onFieldChange('price', val, index)}
                    elementType="input"
                />
            </Grid>
            <Grid item xs={3} className={classes.linkedWorkOrders}>
                <DropdownFilter
                    id={`work-order-${index}`}
                    value={matchingWorkOrdersList?.find(w => w.workOrderId == serviceToEdit?.workOrderId)?.id || null}
                    values={matchingWorkOrdersList}
                    onSelect={(val) => onWOFieldChange(val, index)}
                    showEmpty
                    withTypeAhead
                    newAutoCompleteStyle
                    renderOption={(option) => renderOption(option)}
                />
            </Grid>

            {/* {selectedVehicles?.length > 1 &&
                <Grid item xs={12}>
                    <CustomInput
                        label="Vehicle"
                        shrink
                        showEmpty
                        value={serviceToEdit?.vehicleId || ''}
                        values={mappedSelectedVehicles}
                        onChange={(val) => onFieldChange('vehicleId', val, index)}
                        elementType="dropdown"
                    />
                </Grid>
            } */}

            {/* {selectedVehicles?.length > 1 && (
                <Grid item xs={12}>
                    <Autocomplete
                        id={`service-vehicle-${index}`}
                        options={selectedVehicles}
                        value={serviceToEdit?.vehicleId || null}
                        getOptionLabel={getVehicleOptionLabel}
                        onChange={(event, newValue) => onFieldChange('vehicleId', newValue?.vehicleId || null, index)}
                        renderOption={renderVehicleOption}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Vehicle"
                                variant="outlined"
                                fullWidth
                                InputLabelProps={{
                                    style: { marginTop: '-8px' }
                                }}
                            />
                        )}
                        className={classes.autoComplete}
                    />
                </Grid>
            )} */}
        </>
    );
};